import React from "react";
import { createEditor } from "../../ui/rete";

import "../../ui/styles.css";
import { ScreenGroup } from "../../nodeSystem/ScreenGroup";
import { GraphInputs } from "../../ui/GraphInputs";
import shortID from "../../utils/shortID";
import storage from '../../utils/storage';
import { deletePatchbay, getPatchbaysForLoggedInUser, savePatchbay } from "../../utils/graphql";

const testJSON = `{"id":"BvgDUvXpU8","inputs":[],"screens":[{"id":"FZmGq9QvPE","name":"Starters Screen","type":"Starters","inputs":[{"id":"uOphTEPKAC","name":"TeamsRoster","type":"any[]"},{"id":"fS4dbTzCcK","name":"ShowHide","type":"boolean"},{"id":"1LqLCBXuZA","name":"ShowNextTeam","type":"boolean"}]}],"nodes":[{"id":"X48pUfQtQO","type":"file","inputs":[{"id":"CKQxFfFeG8","name":"url","type":"string"},{"id":"di26SmCaMw","name":"cache","type":"boolean"}],"outputs":[{"id":"3ZvIkKnhtQ","name":"data","type":"any"}],"posX":-214.4155609787486,"posY":-309.0139669653058,"isConstant":false},{"id":"OlJITeGU7q","inputs":[],"outputs":[],"posX":-617.6684490952895,"posY":-163.53655538600788,"isConstant":true,"constantType":"string","value":"dekki-temp.s3-ap-northeast-1.amazonaws.com/test.json"},{"id":"Lmq00EJEHW","type":"objectPath","inputs":[{"id":"65oLUQR3FA","name":"inputJson","type":"any"},{"id":"lJYC3E8p84","name":"path","type":"string"}],"outputs":[{"id":"y4YwsasN4Q","name":"output","type":"any"}],"posX":81.16626094198926,"posY":-282.95515259734253,"isConstant":false},{"id":"em78oE148c","inputs":[],"outputs":[],"posX":-237.86280183457697,"posY":-100.45011343073485,"isConstant":true,"constantType":"string","value":"teams"},{"id":"Cc6yKwYoCW","type":"objectPath","inputs":[{"id":"XdfB0T65R2","name":"inputJson","type":"any"},{"id":"xZ54g2um2a","name":"path","type":"string"}],"outputs":[{"id":"IUuAN0Qsjm","name":"output","type":"any"}],"posX":348.56705989997715,"posY":-163.43057914348822,"isConstant":false},{"id":"gwjb9iCSaM","inputs":[],"outputs":[],"posX":32.45346295187977,"posY":-76.20071156117758,"isConstant":true,"constantType":"string","value":"DFM"},{"id":"sPIWDiOOkS","type":"objectPath","inputs":[{"id":"WQBg8mYcyk","name":"inputJson","type":"any"},{"id":"9kWK36vF3I","name":"path","type":"string"}],"outputs":[{"id":"HvNlYxU58w","name":"output","type":"any"}],"posX":295.71613205940366,"posY":73.48674042320124,"isConstant":false},{"id":"5uAE3ADbRg","inputs":[],"outputs":[],"posX":-7.821651544309034,"posY":94.35234260347636,"isConstant":true,"constantType":"string","value":"BC"}],"connections":{"CKQxFfFeG8":"OlJITeGU7q","65oLUQR3FA":"3ZvIkKnhtQ","lJYC3E8p84":"em78oE148c","xZ54g2um2a":"gwjb9iCSaM","XdfB0T65R2":"y4YwsasN4Q","WQBg8mYcyk":"y4YwsasN4Q","9kWK36vF3I":"5uAE3ADbRg"}}`;

function reducer(state, jsonData) {
  return new ScreenGroup(jsonData);
}

export default ({patchbay, dispatchPatchbay} : {patchbay: ScreenGroup, dispatchPatchbay: Function}) => {

  // const [jsonData, setJsonData] = React.useState('{}');
  // const [patchbay, dispatch] = React.useReducer(reducer, new ScreenGroup('{}'));
  const [componentID, setComponentID] = React.useState(shortID());
  const [editor, setEditor] = React.useState(null);
  const [addRefNodeFunc, setAddRefNodeFunc] = React.useState();
  const [deleteRefNodes, setDeleteRefNodes] = React.useState();

  const [patchbayList, setPatchbayList] = React.useState([]);
  React.useEffect(() => {
    refreshPatchbayList(setPatchbayList, setSelectedPatchbayIdToLoad, patchbay);
  }, [patchbay]);
  const [selectedPatchbayIdToLoad, setSelectedPatchbayIdToLoad] = React.useState((patchbay && patchbay.data && patchbay.data.id) || null);

  return (
    <React.Fragment>
      <div className="App" id={`${patchbay.data.id}-parent`} key={`${patchbay.data.id}-parent`}>
        <p>{patchbay.data.name || 'Untitled'} ({patchbay.data.id})</p>
        <select name="patchbayToLoad" id="patchbayToLoad" value={selectedPatchbayIdToLoad} onChange={val => setSelectedPatchbayIdToLoad(val.target.value)}>
          {
            patchbayList.map(pb => (
              <option value={pb.id}>{pb.name || pb.id}</option>
            ))
          }
        </select>
        <button onClick={() => {
          const pb = patchbayList.find(bay => bay.id === selectedPatchbayIdToLoad);
          if(pb){

            if(!pb.data || pb.data.length === 0 || pb.data === '{}'){
              pb.data = `{
                "id": "${pb.id}",
                "name": "${pb.name}"
              }`;
            }else{
              if(pb.data){
                let changed = false;
                const parsed = JSON.parse(pb.data);
                if(!parsed.id){
                  parsed.id = pb.id;
                  changed = true;
                }
                if(!parsed.name){
                  parsed.name = pb.name;
                  changed = true;
                }
                if(changed){
                  pb.data = JSON.stringify(parsed);
                }
              }
            }
            dispatchPatchbay(pb.data);
            setComponentID(shortID());
          }
        }}>Load</button><button onClick={async () => {
          if(!patchbay.data.name){
            const name = window.prompt('Input Patchbay Name:');
            patchbay.data.name = name;
          }
          await savePatchbay(patchbay.data.id, patchbay.data.name, patchbay.getJson());
          refreshPatchbayList(setPatchbayList, setSelectedPatchbayIdToLoad, patchbay);
          setComponentID(shortID());
        }}>Save</button><button onClick={() => {
          dispatchPatchbay('{}');
          if(patchbayList.length > 0){
            setSelectedPatchbayIdToLoad(patchbayList[0].id);
          }
          refreshPatchbayList(setPatchbayList, setSelectedPatchbayIdToLoad, patchbay);
        }}>New</button>
        <button onClick={async () => {
          if(window.confirm(`Are you sure you want to delete ${patchbay.data.name || 'Untitled'}?`)){
            patchbay.data.name = null;
            await deletePatchbay(patchbay.data.id);
            if(patchbayList.length > 0){
              setSelectedPatchbayIdToLoad(patchbayList[0].id);
            }
            refreshPatchbayList(setPatchbayList, setSelectedPatchbayIdToLoad, patchbay);
            // TODO: delete in firebase
          }
        }}>Delete Loaded Patchbay</button>
        <table>
        <tbody>
        <tr>
        <td><GraphInputs screenGroup={patchbay} addRefNodeFunc={addRefNodeFunc} deleteRefNodeFunc={deleteRefNodes}/></td>
        <td><div id={componentID} key={componentID}
          style={{ width: "85vw", height: "78vh", border: '5px solid green'}}
          ref={ref => {
            return ref && createEditor(ref, patchbay, editor, setEditor, componentID, setAddRefNodeFunc, setDeleteRefNodes, () => setComponentID(shortID()));
          }}
        /></td>
        </tr>
        </tbody>
        </table>
      </div>
    </React.Fragment>
  );
}

const refreshPatchbayList = (setPatchbayList : Function, setSelectedPatchbayIdToLoad : Function, patchbay: ScreenGroup) => {
  getPatchbaysForLoggedInUser().then(patchbays => {
    if(!patchbays) return;
    setPatchbayList(patchbays || []);
    if(patchbay && patchbay.data && patchbay.data.id && patchbays.find(pb => pb.id === patchbay.data.id)){
      setSelectedPatchbayIdToLoad(patchbay.data.id);
    }else{
      if(patchbays.length > 0){
        setSelectedPatchbayIdToLoad(patchbays[0].id);
      }
    }
  });
}